
    Aktuell {{ recommendationCount | number: '.0-0':'de-CH' }} Teilnehmende
  